import { render } from "./ServiceInTripComponent.vue?vue&type=template&id=7863f06b&scoped=true"
import script from "./ServiceInTripComponent.vue?vue&type=script&lang=ts"
export * from "./ServiceInTripComponent.vue?vue&type=script&lang=ts"

import "./ServiceInTripComponent.vue?vue&type=style&index=0&id=7863f06b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7863f06b"

export default script